/* svnty-sizetip.js — THE SIZE TIP (R133 block 2, D3-10, 2026-09-20). the reference's "Get help with finding your
 * size." bubble under the Size guide: shown once per SESSION (once per user session — sessionStorage, not
 * the reference's localStorage), when the size row scrolls into view, its caret centred on the guide button; the X
 * dismisses it for the session. Versioned key so a redesign can show it again. */
(function () {
  'use strict';
  var KEY = 'svnty:size-tip:v1';
  var tip = document.querySelector('[data-svnty-sizetip]');
  if (!tip) return;
  var guide = tip.parentElement ? tip.parentElement.querySelector('[data-svnty-size-guide]') : null;
  if (!guide) return;
  var seen = false;
  try { seen = !!sessionStorage.getItem(KEY); } catch (e) {}
  if (seen) return;
  function place() {
    var host = tip.offsetParent || tip.parentElement;
    /* the guide's INK (glyph + word), not its row box — the button spans the row so its centre is not the word's */
    var kids = guide.children.length ? Array.prototype.slice.call(guide.children) : [guide];
    var gl = Infinity, gr = -Infinity;
    kids.forEach(function (k) { var r = k.getBoundingClientRect(); if (r.width) { gl = Math.min(gl, r.left); gr = Math.max(gr, r.right); } });
    var g = { left: gl, right: gr, width: gr - gl }, h = host.getBoundingClientRect(), t = tip.getBoundingClientRect();
    var centre = g.left + g.width / 2 - h.left;
    /* right edge of the bubble sits under the guide's right edge, then shifts left if it would leave the column */
    var right = h.width - (g.right - h.left);
    tip.style.marginRight = Math.max(0, right) + 'px';   /* in the flow (D4-5): the right margin, not an absolute offset */
    var tipRight = h.width - Math.max(0, right);
    var caretX = Math.min(Math.max(centre - (tipRight - t.width), 16), t.width - 16);
    tip.style.setProperty('--svnty-sizetip-caret', Math.round(caretX) + 'px');
  }
  function show() {
    tip.hidden = false;
    place();
    requestAnimationFrame(place);
    tip.classList.add('is-in');
  }
  function dismiss() {
    tip.classList.remove('is-in');
    setTimeout(function () { tip.hidden = true; }, 200);
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }
  tip.querySelector('[data-svnty-sizetip-close]').addEventListener('click', dismiss);
  guide.addEventListener('click', function () { if (!tip.hidden) dismiss(); });
  window.addEventListener('resize', function () { if (!tip.hidden) place(); });
  if (typeof IntersectionObserver === 'function') {
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); setTimeout(show, 150); }
    }, { threshold: 0.6 });
    io.observe(guide);
  } else { show(); }
})();
